import * as React from 'react';
import {StyleSheet, View, ViewStyle} from 'react-native';

import NewIllustrationUsageHistoryButton from './NewIllustrationUsageHistoryButton';

interface Props {
  onPress: () => void;
}

const BottomNewIllustrationUsageHistoryButton: React.FunctionComponent<
  Props
> = props => {
  const {onPress} = props;
  return (
    <View style={styles.container}>
      <NewIllustrationUsageHistoryButton onPress={onPress} />
    </View>
  );
};

export default React.memo(BottomNewIllustrationUsageHistoryButton);

const styles = StyleSheet.create({
  container: {
    left: 0,
    right: 0,
    position: 'absolute',
    bottom: 16,
    alignItems: 'center',
  } as ViewStyle,
});
